var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',_vm._b({attrs:{"id":_vm.id,"label":_vm.label,"hint":_vm.hint,"type":"password","outlined":""},on:{"input":_vm.onInput},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}},'v-text-field',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }